import React from "react";
import { Outlet } from "react-router-dom";
import PublicHeader from "./PublicHeader";

const PublicLayout: React.FC = () => {
  return (
    <div className="agri-theme-root agri-grain-overlay min-h-screen flex flex-col">
      <PublicHeader />
      <Outlet />
    </div>
  );
};

export default PublicLayout;
